module.exports = __webpack_public_path__ + "img/icon-doc-pdf.e523c273.svg";